import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { EmployeeQuestionnaireStatusesEnum } from '@thinknet-gmbh/platform-common';

export const QUESTIONNAIRE_STATUSES_STYLES = {
  [EmployeeQuestionnaireStatusesEnum.sent]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [EmployeeQuestionnaireStatusesEnum.received]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [EmployeeQuestionnaireStatusesEnum.created]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
  [EmployeeQuestionnaireStatusesEnum.accepted]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [EmployeeQuestionnaireStatusesEnum.declined]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
};

export const ALLOW_ACTION_QUESTIONNAIRE_STATUSES = [
  EmployeeQuestionnaireStatusesEnum.sent,
  EmployeeQuestionnaireStatusesEnum.created,
  EmployeeQuestionnaireStatusesEnum.received,
];

export const QUESTIONNAIRE_MODALS = {
  tableFilter: 'tableFilter',
  delete: 'delete',
  createHealthInsurance: 'createHealthInsurance',
};

export const INITIAL_QUESTIONNAIRE_DATA = {
  _id: '',
  employeePersonalInfo: {
    firstName: '',
    lastName: '',
  },
  createdBy: '',
  department: {
    name: '',
  },
  status: EmployeeQuestionnaireStatusesEnum.created,
  createdAt: '',

  companyId: '',
  company: {
    module: '',
    name: '',
    _id: '',
  },

  job: {
    title: '',
  },
  jobLocation: {
    companyLocation: {
      name: '',
    },
  },
  jobSupervisors: [],
  responsiblePersonsIds: [''],
  responsiblePersons: [
    {
      _id: '',
      profile: {
        displayName: ''
      },
    },
  ],
};
